import React from 'react';

import Title from 'lib/src/components/typography/Title';

import ButtonRow from 'lib/src/components/button/ButtonRow';
import ContentBlock from '@components/layout/contentBlock/ContentBlock';
import ContentItem from '@components/layout/contentBlock/ContentItem';
import ContentRow from '@components/layout/contentBlock/ContentRow';
import LinkButton from '@components/button/LinkButton';
import { FullUser, userRoleValues } from '../../../types/shared/User';
import Breadcrumb from '@components/breadcrumb/Breadcrumb';
import { singleUserBreadcrumb } from '../../../constants/breadcrumbItems';
import UserApplicationsTable from './UserApplicationsTable';

const User: React.FC<UserProps> = ({ user }) => {
    if (!user) return null;

    const { id, firstName, lastName, email, roles } = user.user;

    return (
        <>
            <Breadcrumb items={singleUserBreadcrumb} title={`${firstName} ${lastName}`} />
            <Title>
                User - {firstName} {lastName}
            </Title>

            <ContentBlock>
                <ContentRow>
                    <ContentItem label="Name">
                        <p>{`${firstName} ${lastName}`}</p>
                    </ContentItem>
                    <ContentItem label="Email">
                        <p>
                            <a href={`mailto:${email}`}>{email}</a>
                        </p>
                    </ContentItem>
                    <ContentItem label="Roles">
                        <p>{roles.map(role => userRoleValues[role]).join(', ')}</p>
                    </ContentItem>
                </ContentRow>
            </ContentBlock>

            <ButtonRow alignment="left">
                <LinkButton color="grey" href={`/users/${id}/edit`}>
                    Edit
                </LinkButton>
                <LinkButton color="grey" href={`/users/${id}/edit-password`}>
                    Edit password
                </LinkButton>
                <LinkButton color="red" href={`/users/${id}/delete`}>
                    Delete
                </LinkButton>
            </ButtonRow>

            <Title>Applications</Title>
            <UserApplicationsTable applications={user.challengeApplications} />
        </>
    );
};

interface UserProps {
    user: FullUser;
}
export default User;
